export default __webpack_public_path__ + "static/sfpe-default-social-9cea69b7d24d8c178601c52144c9d687.png";